import React from 'react';

import {
	ApSecondaryNav,
	ApButtonTab,
	colors,
	ApMenuItem,
	ApMenu,
} from '@alixpartners/ui-components';
import SearchDialog from '../SearchDialog';
import { NavLink, useLocation } from 'react-router-dom';
import FilterPanel from './FilterPanel';
import { NAV_CONFIG } from '../utils';
import {
	BackButtonWrapper,
	TransactionsTitle,
	ButtonIcon,
} from './SecondaryNav.styles';

export const SecondaryNav = ({
	transactionsTitle,
	onBackButtonClick,
	showExplorePage,
}) => {
	const location = useLocation();

	return (
		<ApSecondaryNav
			left={
				transactionsTitle ? (
					<BackButtonWrapper>
						<ButtonIcon
							iconName="baseline_arrow_back"
							iconProps={{ iconColor: colors.grey8 }}
							onClick={onBackButtonClick}
						/>
						<TransactionsTitle>{transactionsTitle}</TransactionsTitle>
					</BackButtonWrapper>
				) : (
					NAV_CONFIG.map(tab => {
						if ('path' in tab) {
							const { label, path } = tab;
							return (
								<NavLink to={path} key={path}>
									<ApButtonTab isSelected={location.pathname.includes(path)}>
										{label}
									</ApButtonTab>
								</NavLink>
							);
						} else {
							return (
								<ApMenu
									toggleVariant="hover"
									button={
										<ApButtonTab
											isSelected={tab.child.some(
												child => child.path === location.pathname
											)}
										>
											{tab.label}
										</ApButtonTab>
									}
								>
									{tab.child.map(option => (
										<ApMenuItem
											key={option.value}
											style={{
												backgroundColor:
													option.path === location.pathname
														? colors.green0
														: null,
											}}
										>
											<NavLink
												to={option.path}
												key={option.path}
												disabled={option.disabled}
											>
												{option.label}
											</NavLink>
										</ApMenuItem>
									))}
								</ApMenu>
							);
						}
					})
				)
			}
			right={
				<React.Fragment>
					<FilterPanel />
					<SearchDialog showExplorePage={showExplorePage} />
				</React.Fragment>
			}
		/>
	);
};

export default SecondaryNav;
